export default {
  name: 'Actions',
  props: {
    schedule: {
      type: Object
    },
    workScheduleType: {
      type: String,
      default: 'view'
    }
  },
  computed: {
    isDraft () {
      if (this.schedule.status == 'draft') {
        return true;
      }
      return false;
    }
  },
  methods: {
    publish: function () {
      const path = 'ezuro/schedule/publish/' + this.schedule.id;

      this.setLoading(true);

      this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, [], (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          this.schedule.status = 'confirmed';
          this.filter();
        }

        this.setLoading(false);
      });
    },
    fill: function () {
      const path = 'ezuro/schedule/fill/' + this.schedule.id;

      this.setLoading(true);

      this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, [], (response) => {
        if (response.error) {
          this.ApiRequest.displayErrorDialog(response, this);
        } else {
          this.filter();
        }

        this.setLoading(false);
      });
    },
    filter: function () {
      this.$emit('filter');
    },
    editDateFor (id) {
      this.$emit('editDateFor', id);
    },
    deleteSchedule (id) {
      this.$emit('deleteSchedule', { el: this.$el, id: id });
    },
    copySchedule (id) {
      this.$emit('copySchedule', id);
    },
    downloadExcel (scheduleId, mode = null) {
      this.$emit('downloadExcel', { scheduleId: scheduleId, mode: mode });
    },
    setLoading: function (value) {
      this.$emit('loading', value);
    }
  }
}
